import React, { useState } from "react";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function MembershipModal({ cancelModal, value}) {
  const currencySymbol = value?.country === "UK" ? "£" : "$";
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("YEARLY");
  const {user} = useAuthContext();

  const plan =
    selectedPlan === "MONTHLY"
      ? {
          key: "MONTHLY",
          title: "Monthly",
          price: 12,
          periodText: "per month",
          subText: "Billed monthly",
        }
      : {
          key: "YEARLY",
          title: "Yearly",
          price: 120,
          periodText: "per year",
          subText: `Equivalent to ${currencySymbol}10 per month`,
        };
const handlePay = async () => {
  setMessage("");
  setIsLoading(true);

  try {
    const res = await axios.post(
      `${ApiConnectionString}/api/checkout/start/${selectedPlan}`,
      null,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (!res?.data) {
      setMessage("Checkout url missing.");
      setIsLoading(false);
      return;
    }

    window.location.href = res.data;
  } catch {
    setMessage("Could not start checkout.");
    setIsLoading(false);
  }
};

  return (
    <>
      <div className="modal-backdrop show bcs-modal-backdrop"></div>

      <div
        className="modal show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered bcs-modal-dialog">
          <div className="modal-content border-0 shadow bcs-modal-content">
            <div className="modal-header position-relative flex-column border-0 pb-2 bcs-modal-header">
              <button
                type="button"
                className="btn-close position-absolute top-0 end-0 m-3"
                onClick={cancelModal}
              ></button>

              <div className="text-center w-100 mt-2">
                <div className="bcs-title brand-dark-purple">Payment</div>
              <div className="bcs-subtitle mt-1">
  Once you have subscribed and your profile is verified, it will be visible in the directory.
</div>
              </div>

              <div className="w-100 bcs-divider"></div>
            </div>

            <div className="modal-body pt-2 bcs-modal-body">
              <div className="ppfGroupCard">
                <div className="ppfGroupCardBody">
 <div className="ppfSectionHint">
  Please choose one of the options below to subscribe and make your profile live
  in the directory.
</div>

                  <div className="ppfPlanGrid">
                    <button
                      type="button"
                      className={
                        "ppfPlanCard " +
                        (selectedPlan === "YEARLY" ? "ppfPlanCardActive" : "")
                      }
                      onClick={() => setSelectedPlan("YEARLY")}
                      disabled={isLoading}
                    >
                      <div className="ppfPlanTop">
                        <div className="ppfPlanTitle">Yearly</div>
                        <div className="ppfPlanTag ppfPlanTagStrong">
                          Best value
                        </div>
                      </div>

                      <div className="ppfPlanPriceRow">
                        <div className="ppfPlanPrice">{currencySymbol}120</div>
                        <div className="ppfPlanPeriod">per year</div>
                      </div>

                      <div className="ppfPlanSub">
                        Equivalent to {currencySymbol}10 per month
                      </div>
                    </button>

                    <button
                      type="button"
                      className={
                        "ppfPlanCard " +
                        (selectedPlan === "MONTHLY" ? "ppfPlanCardActive" : "")
                      }
                      onClick={() => setSelectedPlan("MONTHLY")}
                      disabled={isLoading}
                    >
                      <div className="ppfPlanTop">
                        <div className="ppfPlanTitle">Monthly</div>
                        <div className="ppfPlanTag">Flexible</div>
                      </div>

                      <div className="ppfPlanPriceRow">
                        <div className="ppfPlanPrice">{currencySymbol}12</div>
                        <div className="ppfPlanPeriod">per month</div>
                      </div>

                      <div className="ppfPlanSub">Billed monthly</div>
                    </button>
                  </div>

                  <div className="ppfSelectedSummary">
                    <div className="ppfSelectedSummaryTop">
                      <div className="fw-semibold">Selected plan</div>
                      <div className="fw-semibold">
                        {currencySymbol}
                        {plan.price}{" "}
                        <span className="text-muted fw-normal">
                          {plan.periodText}
                        </span>
                      </div>
                    </div>

                    <hr className="ppfDivider" />

                    <div className="ppfHelpText">
                      By continuing, you agree to pay {currencySymbol}
                      {selectedPlan === "YEARLY" ? "120" : "12"}{" "}
                      {selectedPlan === "YEARLY" ? "per year" : "per month"}. You
                      can update your listing details at any time.
                    </div>

                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn ppfBtnPrimary w-100"
                        onClick={handlePay}
                        disabled={isLoading}
                      >
                        {isLoading ? "Redirecting" : "Complete"}
                      </button>
                    </div>

                    {message ? (
                      <div className="text-muted mt-2">{message}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center border-0 pt-0 bcs-modal-footer"></div>
          </div>
        </div>
      </div>
    </>
  );
}